import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const MailIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 25" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.03624 7.05797C2.03624 5.40111 3.37938 4.05797 5.03624 4.05797H19.0362C20.6931 4.05797 22.0362 5.40111 22.0362 7.05797V8.04245C22.0364 8.05219 22.0364 8.06192 22.0362 8.07165V17.058C22.0362 18.7148 20.6931 20.058 19.0362 20.058H5.03624C3.37938 20.058 2.03624 18.7148 2.03624 17.058V8.07164C2.0361 8.06192 2.0361 8.05219 2.03624 8.04246V7.05797ZM4.03624 9.92649V17.058C4.03624 17.6103 4.48395 18.058 5.03624 18.058H19.0362C19.5885 18.058 20.0362 17.6103 20.0362 17.058V9.92649L13.7003 14.1504C12.6926 14.8222 11.3798 14.8222 10.3721 14.1504L4.03624 9.92649ZM20.0362 7.52278L12.5909 12.4863C12.255 12.7103 11.8174 12.7103 11.4815 12.4863L4.03624 7.52278V7.05797C4.03624 6.50568 4.48395 6.05797 5.03624 6.05797H19.0362C19.5885 6.05797 20.0362 6.50568 20.0362 7.05797V7.52278Z"
            />
        </SvgIcon>
    );
};

export default MailIcon;
